export const roles = [
    {key: 'User', val: 'user'},
    {key: 'Admin', val: 'admin'}
];